
import OperatIndex from "./operat/index.vue";
import OperatContent from "./operat/content.vue";
import { Component, Prop, Vue, Watch } from 'vue-facing-decorator'
import { LockDec } from "@/decorators";

@Component({
  components: {
    OperatIndex,
    OperatContent,
  },
})
export default class extends Vue {
  step = 0
  formData: any = {}
  loading = false
  submitLoading = false;
  created() {
    this.formData = this.getDefaultData()
    if (this.$route.query.id) {
      this.getData();
    }
  }
  getDefaultData() {
    return {
      name: "",
      unit: "",
      description: "",
      categoryId: [],
      image: [],
      video: [],
      spec: [],
      skuList: [],
      price: "",
      originPrice: "",
      type: 1,
      sort: "",
      showPrice: "",
      minBuy: 1,
      expressType: 1,
      postageId: null,
      sellStatus: 1,
      sellStartTime: null,
      buyButtonType: 1,
      buyButton: "",
      message: [],
      buyNum: 0,
      virtualSendList: [],
    };
  }

  /**
   * 发货配置回填。
   *
   * 后端按 sort DESC, createTime DESC 返回（`sort` 不在 DTO 里，前端改不了），
   * 直接显示顺序是反的，按 (skuId, id) 升序排成「规格分组、组内按填写顺序」。
   *
   * 顺带把配置行的 skuId 映射回规格下拉的 value（就是 SKU 自己的 id），
   * 并挂上渲染用的 _key —— 后端数据没有它，v-for 的 key 会全是 undefined。
   *
   * 规格已经被删掉的配置：value 留空让用户重选，别猜也别直接丢掉 ——
   * 丢掉的配置会被后端的删除逻辑真删掉。
   */
  normalizeSendList(list, skuList) {
    /** 一律转成数字：buildSendList 靠 typeof == 'number' 判断「已有规格」还是「新建规格」，
        这里要是漏个字符串下去，skuId/skuIndex 两个都不会发，后端只会报个没头没脑的错 */
    let skuIds = new Set((skuList || []).map((item) => Number(item.id)).filter((id) => !!id));
    return (list || [])
      .slice()
      .sort((a, b) => Number(a.skuId) - Number(b.skuId) || Number(a.id) - Number(b.id))
      .map((item) => ({
        ...item,
        _key: this.$getUUID(),
        skuValue: skuIds.has(Number(item.skuId)) ? Number(item.skuId) : "",
      }));
  }


  async getData() {
    this.loading = true;
    let { error, data } = await this.$get("/manager/goods/detail", {
      id: this.$route.query.id,
    });
    setTimeout(() => {
      this.loading = false;
    });
    if (error) return;
    this.formData = data;
    this.formData.virtualSendList = this.normalizeSendList(data.virtualSendList, data.skuList);
  }


  /**
   * 只发后端 DTO 认识的字段。
   *
   * `id` 必须回传：后端按 `Not(In(virtualSendIds))` 删掉没带 id 的行，而
   * order_virtual_send 的幂等键正是 virtualSendId —— 老行被删掉再以新 id 插入，
   * 队列重试时会把券/会员重复发一次（见 virtual.deliver.service 的幂等逻辑）。
   *
   * 规格用二选一：已有 SKU 发真实 `skuId`；本次新建的 SKU 商品存完才有 id，
   * 发它在 skuList 里的下标 `skuIndex`，由后端解析。
   */
  buildSendList() {
    return (this.formData.virtualSendList || []).map((item) => {
      let row: any = { type: item.type, remark: item.remark || "" };
      if (item.id) row.id = item.id;
      if (typeof item.skuValue == "number") {
        row.skuId = item.skuValue;
      } else if (typeof item.skuValue == "string" && item.skuValue.indexOf("new-") == 0) {
        row.skuIndex = Number(item.skuValue.slice(4));
      }
      if (item.type == 2) {
        row.couponId = item.couponId;
        row.count = item.count;
      }
      if (item.type == 3) {
        row.vipLevelId = item.vipLevelId;
        row.vipMonth = item.vipMonth;
      }
      /** 接口通知的 UI 没做，已有配置原样带回去，否则会被上面的删除逻辑干掉 */
      if (item.type == 4) {
        row.notifyUrl = item.notifyUrl;
        row.notifyParams = item.notifyParams;
      }
      return row;
    });
  }

  /** 虚拟商品的必填项先在前端拦一道，省一次必然失败的往返；文案和后端 ApiException 对齐 */
  checkVirtual() {
    if (this.formData.type != 2) return true;
    let list = this.formData.virtualSendList || [];
    if (!list.length) {
      this.$error("请配置虚拟商品的发货方式");
      return false;
    }
    for (let item of list) {
      if (item.skuValue === undefined || item.skuValue === "") {
        this.$error("发货配置缺少商品规格");
        return false;
      }
      if (item.type == 2 && !item.couponId) {
        this.$error("请选择要发放的优惠券");
        return false;
      }
      if (item.type == 3 && !item.vipLevelId) {
        this.$error("请选择要发放的会员等级");
        return false;
      }
      if (item.type == 3 && !(Number(item.vipMonth) > 0)) {
        this.$error("请填写会员时长");
        return false;
      }
    }
    return true;
  }

  @LockDec("submitLoading")
  async submit() {
    if (this.$route.query.type == "clone") {
      delete this.formData.id;
    }
    if (!this.checkVirtual()) return;
    let payload = {
      ...this.formData,
      virtualSendList: this.buildSendList(),
    };
    let { error, data, message } = await this.$post(
      "/manager/goods/operat",
      payload
    );
    if (error) return this.$error(message);
    if (this.formData.id) {
      // this.$goto({
      //   name: "goods-list",
      // });
      this.$router.back()
      return this.$success("更新成功");
    }
    this.$success("保存成功");
    this.formData = this.getDefaultData();
  }
} 
